module.exports = __webpack_public_path__ + "static/media/Agreetment.2202ac8d.pdf";